<div class="grid" *ngIf="!habilitadoEditar()">
	<div class="col-12">
		<div class="card">
			<div class="z-1 text-center">
				<div class="text-900 font-bold text-7xl mb-4">Acesso Negado</div>
				<p class="line-height-3 mt-0 mb-5 text-700 text-xl font-medium">Este pacote já foi pago e não pode ser
					modificado</p>
				<p-button [routerLink]="['/apps/orcamentos-e-pacotes']"
					styleClass="p-button-help font-medium p-button-raised">Voltar</p-button>
			</div>
		</div>
	</div>
</div>
<div class="grid " *ngIf="habilitadoEditar()">
	<div class="col-12">
		<div class="card">
			<form>
				<div class="formgroup">
					<div class="flex justify-content-center" *ngIf="isExibirSpinnerPrincipal()">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-full mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
				</div>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid" *ngIf="orcamento && !isExibirSpinnerPrincipal()">

						<div class="form-group field col-12 md:col-2">
							<label>Nº da Proposta</label>
							<label class="form-control" id="razaoSocial">{{ orcamento.numeroOrcamento }}</label>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="tipo">Tipo</label>
							<p-dropdown *ngIf="!orcamento.vencido" [options]="tiposOrcamento" optionLabel="label"
								optionValue="value" emptyFilterMessage="Nenhum registro" name="tipo" ngModel
								#tipo="ngModel" [(ngModel)]="tipoOrcamentoSelecionado">
							</p-dropdown>
							<label *ngIf="orcamento.vencido" class="form-control">{{orcamento.tipo}}</label>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="dataOrcamento">Data da Proposta</label>
							<label class="form-control" id="valorProposta">{{ orcamento.dataOrcamento |
								date:'dd/MM/yyyy' }}</label>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="interessado">Interessado</label>
							<div class="p-inputgroup" *ngIf="orcamento.tipo === 'ORCAMENTO' && !orcamento.vencido">
								<label class="form-control-agrupado">{{ orcamento.interessado?.nome }}
								</label>
								<button type="button" pButton pRipple icon="pi pi-pencil" pTooltip="Editar Interessado"
									class="p-button-success" style="box-shadow: none;" (click)="abrirDialogCliente()">
								</button>
							</div>

							<label
								*ngIf="(orcamento.tipo === 'PACOTE' && orcamento.status !== 'PAGO') || orcamento.vencido"
								class="form-control">{{ orcamento.interessado?.nome }}
							</label>
						</div>

						<div class="field col-12 md:col-2">
							<label htmlFor="validadeProposta">Validade (dias)</label>
							<input type="number" pInputText name="validadeProposta" ngModel #validadeProposta="ngModel"
								[(ngModel)]="orcamento.validadeProposta" />
						</div>
						<div class="form-group field col-12 md:col-2">
							<label>Valor da Proposta</label>
							<label class="form-control" id="valorProposta">{{ orcamento.valorProposta | currency:'BRL'
								}}</label>
						</div>

						<div class="field col-12 md:col-2" *ngIf="orcamento.tipo === 'ORCAMENTO' && !orcamento.vencido">
							<label htmlFor="desconto">Desconto</label>
							<p-inputNumber suffix="%" name="desconto" ngModel #desconto="ngModel" [max]="100"
								[allowEmpty]="false" [minFractionDigits]="2" [maxFractionDigits]="2"
								[(ngModel)]="orcamento.desconto" (onBlur)="calcularValorProposta()">
							</p-inputNumber>
						</div>
						<div class="field col-12 md:col-2" *ngIf="orcamento.tipo === 'PACOTE' || orcamento.vencido">
							<label htmlFor="desconto">Desconto</label>
							<label class="form-control" id="desconto">
								{{ (orcamento.desconto !== undefined ? orcamento.desconto / 100 : 0) | percent:'1.2-2'
								}}
							</label>
						</div>

						<div class="field col-12 md:col-6" *ngIf="orcamento.tipo === 'ORCAMENTO' && !orcamento.vencido">
							<label htmlFor="condicaoPagamento">Condicão do Pagamento</label>
							<input type="text" pInputText name="condicaoPagamento" ngModel #condicaoPagamento="ngModel"
								[(ngModel)]="orcamento.condicaoPagamento" />
						</div>
						<div class="field col-12 md:col-6" *ngIf="orcamento.tipo === 'PACOTE' || orcamento.vencido">
							<label htmlFor="condicaoPagamento">Condicão do Pagamento</label>
							<label class="form-control" id="condicaoPagamento">{{ orcamento.condicaoPagamento }}</label>
						</div>
						<div class="form-group field col-12 md:col-2">
							<label>Status</label>
							<label class="form-control" id="razaoSocial">{{ orcamento.status }}</label>
						</div>

						<!-- <div class="form-group field col-12 md:col-2" *ngIf="orcamento.status === 'PAGO'">
							<label>Valor Pago</label>
							<label class="form-control" id="razaoSocial">{{ orcamento.valorPago | currency:'BRL'
								}}</label>
						</div> -->
						<div class="col-12">
							<p-table #dt1 [value]="listaItensOrcamento" dataKey="id" [rows]="10" [rowHover]="true"
								styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
								styleClass=" p-datatable-sm">
								<ng-template pTemplate="caption">
									<div class="flex justify-content-start flex-column sm:flex-row">
										<button
											*ngIf="orcamento.tipo === 'ORCAMENTO' && !orcamento.vencido && orcamento.status === 'ABERTO'"
											pButton pRipple class="p-button-primary" pTooltip="Adicionar Item ao Pacote"
											icon="pi pi-shopping-cart" style="box-shadow: none;" type="button"
											(click)="abrirDialogItem()" [disabled]="progressoRequisicao">
										</button>

									</div>
								</ng-template>

								<ng-template pTemplate="header">
									<tr>
										<th>Descrição</th>
										<th>Quantidade</th>
										<th>Valor Unitário</th>
										<th>Desconto Item</th>
										<th>Valor Total</th>
										<th>Excluir</th>
									</tr>
								</ng-template>
								<ng-template *ngIf="listaItensOrcamento.length > 0 && orcamento.status !== 'ABERTO'"
									pTemplate="body" let-item let-i="rowIndex">

									<tr>
										<td>
											<label>{{ item.nomeItem }}</label>
										</td>
										<td>

											<label class="form-control">{{ item.quantidadeProposta }}</label>
										</td>
										<td>

											<label class="form-control">{{ item.valorUnitario | currency:'BRL'
												}}</label>
										</td>
										<td>
											<label class="form-control">{{ item.descontoItem }}</label>
										</td>
										<td>
											<label class="form-control">{{ (item.quantidadeProposta *
												item.valorUnitario)
												- ((item.quantidadeProposta * item.valorUnitario)
												* (item.descontoItem / 100)) | currency:'BRL' }}</label>
										</td>
									</tr>
								</ng-template>
								<ng-template *ngIf="listaItensOrcamento.length > 0 && orcamento.status === 'ABERTO'"
									pTemplate="body" let-item let-i="rowIndex">
									<tr>
										<td>
											<label>{{ item.nomeItem }}</label>
										</td>
										<td>
											<input type="text" name="quantidade{{i}}" pInputText
												[(ngModel)]="item.quantidadeProposta" (input)="calcularValorTotal()" />

										</td>
										<td>
											<p-inputNumber name="valorUnitario{{i}}" [allowEmpty]="false"
												[(ngModel)]="item.valorUnitario" mode="currency"
												inputId="currency-brazil" currency="BRL" locale="pt-BR"
												(onBlur)="calcularValorTotal()">
											</p-inputNumber>
										</td>
										<td>
											<p-inputNumber suffix="%" name="desconto{{i}}" [max]="100"
												[minFractionDigits]="2" [maxFractionDigits]="2" [allowEmpty]="false"
												[(ngModel)]="item.descontoItem" (onBlur)="calcularValorTotal()">
											</p-inputNumber>
										</td>
										<td>
											<label class="form-control">{{ (item.quantidadeProposta *
												item.valorUnitario)
												- ((item.quantidadeProposta * item.valorUnitario)
												* (item.descontoItem / 100)) | currency:'BRL' }}</label>
										</td>

										<td>
											<button *ngIf="orcamento.status === 'ABERTO'" pButton pRipple
												pTooltip="Excluir" type="button" icon="pi pi-trash"
												class="p-button-danger" (click)="excluirItemOrcamento(item.id)"
												[disabled]="progressoRequisicao">
											</button>
											<button *ngIf="orcamento.status !== 'ABERTO'" pButton pRipple type="button"
												icon="pi pi-trash" class="p-button-danger" disabled>
											</button>
										</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="summary">
									<div class="flex align-items-center justify-content-between">
										<div>
											Há {{listaItensOrcamento ? listaItensOrcamento.length : 0 }} itens inseridos
											na Proposta.
										</div>
										<div>
											Total: {{ valorTotalItens | currency:'BRL' }}
										</div>
									</div>
								</ng-template>
							</p-table>

						</div>
					</div>

					<div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!isExibirSpinnerPrincipal()">
						<div class="field col-12 md:col-4">
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso" type="button" pButton
								icon="pi pi-check" label="Atualizar"
								class="p-button-outlined p-button-success md:w-9rem" (click)="atualizar()">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="button" pButton icon="pi pi-spin pi-spinner" label="Atualizar"
									class="p-button-outlined p-button-success md:w-9rem" disabled>
								</button>
							</ng-template>
						</div>
						<div class="field col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/orcamentos-e-pacotes"></button>
						</div>
					</div>

				</div>
			</form>

			<p-dialog header="Clientes" [(visible)]="exibirDialogCliente" [modal]="true" [draggable]="false"
				[resizable]="false" [closable]="true">
				<div class="card">
					<div class="flex justify-content-center" *ngIf="exibirSpinnerDialogCliente">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<p-table #tbDialogCliente [value]="listaClientes" dataKey="id"
						[rows]="itensClientesPaginados ? itensClientesPaginados.size : 0" [loading]="loadingTable"
						[rowHover]="true" [paginator]="true" (onPage)="onPageChangeCliente($event)"
						[totalRecords]="itensClientesPaginados ? itensClientesPaginados.totalElements : 0" [lazy]="true"
						[showCurrentPageReport]="true" responsiveLayout="scroll" styleClass=" p-datatable-sm"
						*ngIf="!exibirSpinnerDialogCliente"
						currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros">
						<ng-template pTemplate="caption">
							<div class="flex justify-content-end flex-column sm:flex-row">

								<div>
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input pInputText type="text" #filter (input)="buscarDialogCliente($event)"
											placeholder="Buscar" class="w-full" />
									</span>
									<span class="ml-2">
										<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
											pTooltip="Limpar Filtros" (click)="limparDialogCliente()"></button>
									</span>
								</div>
							</div>
						</ng-template>
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="nome">
									Nome
									<p-sortIcon field="nome">
									</p-sortIcon>
								</th>
								<th pSortableColumn="apelido">
									Apelido
									<p-sortIcon field="apelido">
									</p-sortIcon>
								</th>
								<th pSortableColumn="cpf">
									CPF
									<p-sortIcon field="cpf">
									</p-sortIcon>
								</th>
								<th style="text-align: center;">
									Selecionar
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item>
							<tr>
								<td>
									{{item.nome}}
								</td>
								<td>
									{{item.apelido}}
								</td>
								<td>
									{{item.cpf ? (item.cpf | cpfPipe ) : 'INDEFINIDO' }}
								</td>
								<td style="text-align: center;">
									<button pButton pRipple pTooltip="Selecionar Cliente"
										(click)="selecionarCliente(item)" icon="pi pi-plus"
										class="p-button-info mr-2 mb-2">
									</button>
								</td>

							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">Nenhum registro encontrado.</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="loadingbody">
							<tr>
								<td colspan="7">Carregando clientes. Por favor aguarde.</td>
							</tr>
						</ng-template>
					</p-table>

				</div>
				<p-footer>
					<button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-danger mt-2"
						(click)="exibirDialogCliente = false"></button>
				</p-footer>
			</p-dialog>

			<p-dialog [header]="tipoOrcamentoSelecionado === 'PACOTE' ? 'Adicionar Serviço':'Adicionar Produto/Serviço'"
				[(visible)]="exibirDialogItem" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true">
				<div class="card">
					<div class="flex justify-content-center" *ngIf="exibirSpinnerDialogItem">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<p-table #tbItensDialog [value]="listaItensDialog" dataKey="id" [rows]="10" [rowHover]="true"
						styleClass="p-datatable-gridlines" [paginator]="true" responsiveLayout="scroll"
						styleClass=" p-datatable-sm" [globalFilterFields]="['codigo', 'descricao']"
						*ngIf="!exibirSpinnerDialogItem">
						<ng-template pTemplate="caption">
							<div class="flex justify-content-between flex-column sm:flex-row">
								<p-dropdown *ngIf="tipoOrcamentoSelecionado !== 'PACOTE'" [options]="tiposItem"
									optionLabel="label" optionValue="value" emptyFilterMessage="Nenhum registro"
									name="situacao" ngModel #situacao="ngModel" [(ngModel)]="tipoItemSelecionado"
									(onChange)="carregarItens()">
								</p-dropdown>
								<div *ngIf="tipoOrcamentoSelecionado === 'PACOTE'"></div>
								<div>
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input pInputText type="text" #filter (input)="buscar(tbItensDialog, $event)"
											placeholder="Buscar" class="w-full" />
									</span>
									<span class="ml-2">
										<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
											pTooltip="Limpar Filtros" (click)="limpar(tbItensDialog)"></button>
									</span>
								</div>
							</div>
						</ng-template>
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="codigo">
									<div>
										Código
									</div>
								</th>
								<th pSortableColumn="descricao">
									<div>
										Descrição
									</div>
								</th>
								<th>
									<div>
										Estoque atual
									</div>
								</th>

								<th style="text-align: center;">
									<div>
										Selecionar
									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item let-i="rowIndex">
							<tr>
								<td>
									<label>{{ item.codigo }}</label>
								</td>
								<td>
									<label>{{ item.descricao }}</label>
								</td>
								<td>
									<label>{{ item.estoqueAtual }} {{ item.descricaoUnidadeMedida }}</label>
								</td>

								<td style="text-align: center;">
									<button pButton pRipple pTooltip="Adicionar" type="button" icon="pi pi-check"
										class="p-button-success" (click)="adicionarItem(item)">
									</button>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="summary">
							<div class="flex align-items-center justify-content-between">
								Há {{listaItensDialog ? listaItensDialog.length : 0 }} Itens
								disponíveis.
							</div>
						</ng-template>
					</p-table>

				</div>
				<p-footer>
					<button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-danger mt-2"
						(click)="exibirDialogItem = false"></button>
				</p-footer>
			</p-dialog>
			<p-confirmDialog [style]="{width: '50vw'}">
			</p-confirmDialog>
		</div>
	</div>
</div>